import Swiper from "swiper/bundle";

export class Cart {
  root = window.Shopify.routes.root;
  sections = "cart-template,cart-aside,header";
  useCartAside = false;
  giftData = null;
  blockGiftData = null;
  ceramicMugData = null;
  recommendedItemsSwiper = null;

  constructor() {
    const $body = document.querySelector("body");
    this.useCartAside = $body.dataset?.useCartAside === "true" ? true : false;

    const scriptTag = document.querySelector(".cart-aside__json");
    if (scriptTag) {
      const jsonText = scriptTag?.textContent;
      const data = JSON.parse(jsonText);
      this.giftData = data;
    }

    //March 2026 add the ability to configure Gifts From Shopify Blocks
    const blockScriptTag = document.querySelector(
      ".cart-aside__block-gifting-json"
    );
    if (blockScriptTag) {
      this.blockGiftData = JSON.parse(blockScriptTag?.textContent);
    }

    // Ceramic mug upsell — always present in DOM even when feature is disabled,
    // so JS can clean up any mug variants left in cart if the feature is switched off
    const ceramicMugScriptTag = document.querySelector(
      ".cart-aside__ceramic-mug-json"
    );
    if (ceramicMugScriptTag) {
      try {
        this.ceramicMugData = JSON.parse(ceramicMugScriptTag.textContent);
      } catch (e) {
        this.ceramicMugData = null;
      }
    }
  }

  // these functions are used to re-render
  reRenderHeader = ($header, newSectionText) => {
    // Get the text of the new section and render it to a div thats not in the DOM
    const $newSection = document.createElement("div");
    $newSection.innerHTML = newSectionText;
    const $newHeader = $newSection.querySelector("header.header");

    // Set the desktop cart link to the new sections desktop cart link
    const $currentDesktopCartLink = $header.querySelector(
      ".navbar__desktop .header__cart-link"
    );
    const $newDesktopCartLink = $newHeader.querySelector(
      ".navbar__desktop .header__cart-link"
    );
    $currentDesktopCartLink.innerHTML = $newDesktopCartLink.innerHTML;

    // // Set the mobile cart link to the new sections mobile cart link
    // const $currentMobileCartLink = $header.querySelector(
    //   ".navbar__mobile .header__cart-link"
    // );
    // const $newMobileCartLink = $newHeader.querySelector(
    //   ".navbar__mobile .header__cart-link"
    // );
    // $currentMobileCartLink.innerHTML = $newMobileCartLink.innerHTML;

    // // Set the Mobile Menu cart link to the new sections mobile menu cart link
    // const $currentMobileMenuCartLink = $header.querySelector(
    //   ".menu__mobile .menu__cart"
    // );
    // const $newMobileMenuCartLink = $newHeader.querySelector(
    //   ".menu__mobile .menu__cart"
    // );
    // $currentMobileMenuCartLink.innerHTML = $newMobileMenuCartLink.innerHTML;

    // // Set the navbar cart popout to the new sections navbar cart popout
    // const $currentNavbarCart = $header.querySelector(".nav__bar-cart");
    // const $newNavbarCart = $newHeader.querySelector(".nav__bar-cart");
    // $currentNavbarCart.innerHTML = $newNavbarCart.innerHTML;
  };

  addLineItemEventListeners = ($lineItem, type) => {
    const key = $lineItem.dataset.key;
    const productId = $lineItem.dataset.productId;
    const variantId = $lineItem.dataset.variantId;
    const sellingPlanId = $lineItem.dataset.sellingPlanId;
    const quantity = $lineItem.dataset.quantity;
    const $lineItemQuantitys = $lineItem.querySelectorAll(
      ".line-item__quantity"
    );

    // Loop through the line items quantity controlls and add the event listeners
    $lineItemQuantitys.forEach(($lineItemQuantity) => {
      const $lineItemQuantityDecrease = $lineItemQuantity.querySelector(
        ".line-item__quantity-decrease"
      );
      const $lineItemQuantityValue = $lineItemQuantity.querySelector(
        ".line-item__quantity-value"
      );
      const $lineItemQuantityIncrease = $lineItemQuantity.querySelector(
        ".line-item__quantity-increase"
      );

      // Add the decrease evetn listeners
      $lineItemQuantityDecrease.addEventListener("click", async (event) => {
        event.preventDefault();
        const quantity = parseInt($lineItemQuantityValue.textContent);
        if (quantity > 0) {
          const decreaseResponse = await this.updateLineItemQuantity(
            key,
            parseInt(quantity) - 1
          );

          //this.reRenderSections(decreaseResponse.sections);
        }
      });

      //add the increase event listeners
      $lineItemQuantityIncrease.addEventListener("click", async (event) => {
        event.preventDefault();
        const increaseResponse = await this.updateLineItemQuantity(
          key,
          parseInt($lineItemQuantityValue.textContent) + 1
        );

        //this.reRenderSections(increaseResponse.sections);
      });
    });

    // Loop through the line items remove buttons and add the event listeners
    const $lineItemRemove = $lineItem.querySelectorAll(".line-item__remove");
    $lineItemRemove.forEach(($element) => {
      $element.addEventListener("click", async (event) => {
        event.preventDefault();
        const removeResponse = await this.removeLineItemFromCart(key);
        // this.reRenderSections(removeResponse.sections);
      });
    });

    const $lineItemUpgrade = $lineItem.querySelector(".line-item__upgrade");
    if ($lineItemUpgrade) {
      $lineItemUpgrade.addEventListener("click", (event) => {
        event.preventDefault();
        this.addSubscription(
          $lineItemUpgrade.dataset.key,
          $lineItemUpgrade.dataset.variantId,
          parseInt($lineItemUpgrade.dataset.quantity),
          $lineItemUpgrade.dataset.sellingPlan
        );
      });
    }

    // Add the subscription plan select event listeners
    const $subscriptionSelect = $lineItem.querySelector(
      ".line-item__subscription-select"
    );
    if ($subscriptionSelect) {
      $subscriptionSelect.addEventListener("change", (event) => {
        event.preventDefault();
        this.addSubscription(key, variantId, quantity, event.target.value);
      });
    }
  };

  setUpCartTemplate = ($cartTemplate) => {
    /* 
      Find the line items in the cart tempalte and if they exist loop through and
      add the events listners
    */
    const $lineItemsContainer = $cartTemplate.querySelector(
      ".cart-template__line-items"
    );
    if ($lineItemsContainer) {
      const $lineItems = $lineItemsContainer.querySelectorAll(
        ".cart-template__line-item"
      );
      $lineItems.forEach(($lineItem) => {
        this.addLineItemEventListeners($lineItem, "template");
      });

      const $clearCarts = $cartTemplate.querySelectorAll(
        ".cart-template__clear"
      );
      $clearCarts.forEach(($clearCart) => {
        $clearCart.addEventListener("click", (event) => {
          event.preventDefault();
          this.clearCart();
        });
      });
    }

    const $mobileDeliveryButton = $cartTemplate.querySelector(
      ".cart-template__delivery.cart-template__delivery--mobile"
    );
    const $mobileDeliveryPopup = $cartTemplate.querySelector(
      ".cart-template__delivery-popup.cart-template__delivery-popup--mobile"
    );
    if ($mobileDeliveryButton && $mobileDeliveryButton) {
      $mobileDeliveryPopup.addEventListener("click", (event) => {
        if (event.target == $mobileDeliveryPopup) {
          $mobileDeliveryPopup.classList.add(
            "opacity-0",
            "pointer-events-none"
          );
        }
      });
      $mobileDeliveryButton.addEventListener("click", (event) => {
        event.preventDefault();
        $mobileDeliveryPopup.classList.remove(
          "opacity-0",
          "pointer-events-none"
        );
      });
    }
  };

  reRenderCartTemplate = ($element, newSectionText) => {
    // Get the text of the new section and render it to a div thats not in the DOM
    const $newSection = document.createElement("div");
    $newSection.innerHTML = newSectionText;

    const $currentTemplateContainer = $element.querySelector(
      ".cart-template__container"
    );
    const $newTemplateContainer = $newSection.querySelector(
      ".cart-template__container"
    );

    if (
      $currentTemplateContainer.classList.contains(
        "cart-template__container--empty"
      ) ||
      $newTemplateContainer.classList.contains(
        "cart-template__container--empty"
      )
    ) {
      // If either the new or old cart is empty repalce the entire cart
      $currentTemplateContainer.innerHTML = $newTemplateContainer.innerHTML;
    } else {
      // Set the current line items to the new line items
      const $currentLineItems = $currentTemplateContainer.querySelector(
        ".cart-template__line-items"
      );
      const $newLineItems = $newTemplateContainer.querySelector(
        ".cart-template__line-items"
      );

      if ($currentLineItems && $newLineItems) {
        $currentLineItems.innerHTML = $newLineItems.innerHTML;
      }

      // Set the current sumamry to the new summmary
      const $currentSummary = $currentTemplateContainer.querySelector(
        ".cart-template__summary"
      );
      const $newSummary = $newTemplateContainer.querySelector(
        ".cart-template__summary"
      );

      if ($currentSummary && $newSummary) {
        $currentSummary.innerHTML = $newSummary.innerHTML;
      }
    }

    // Set the cart template  to the new cart template
    const $newCartTemplate = $newSection.querySelector(".cart-template");
    $element.innerHTML = $newCartTemplate.innerHTML;

    this.setUpCartTemplate($element);
  };

  setUpCartAside = ($cartAside) => {
    console.log("TEST");

    // Recommended product cards - covers both the desktop side panel and the mobile swiper.
    // Both containers are replaced on every re-render, so listeners are never doubled up.
    const $recomendedItemProductCards = $cartAside.querySelectorAll(
      ".recomended-product-card"
    );
    $recomendedItemProductCards.forEach(($recomendedItemProductCard) => {
      const $recomendedAdd = $recomendedItemProductCard.querySelector(
        ".recomended-product-card__add"
      );

      $recomendedAdd?.addEventListener("click", (event) => {
        event.preventDefault();
        const { variantId, sellingPlanId } = $recomendedItemProductCard.dataset;
        this.quickAddItemToCart(variantId, sellingPlanId);
      });
    });

    /* 
      Find the line items in the cart aside and if they exist loop through and
      add the events listners
    */
    const $lineItemsContainer = $cartAside.querySelector(
      ".cart-aside__line-items"
    );
    if ($lineItemsContainer) {
      const $lineItems = $lineItemsContainer.querySelectorAll(
        ".cart-aside__line-item"
      );
      $lineItems.forEach(($lineItem) => {
        this.addLineItemEventListeners($lineItem, "aside");
      });

      const $recomendedItem = $cartAside.querySelector(
        ".cart-aside__recommended-item"
      );
      if ($recomendedItem) {
        const $recomendedItemAdd = $recomendedItem.querySelector(
          ".recommended-item__add"
        );

        $recomendedItemAdd?.addEventListener("click", (event) => {
          event.preventDefault();
          const productId = $recomendedItem.dataset.productId;
          const variantId = $recomendedItem.dataset.variantId;
          this.quickAddItemToCart(variantId);
        });
      }
    }

    const $cartAsideDeliveryNote = $cartAside.querySelector(
      ".cart-aside__delivery-note"
    );
    const $deliveryNoteButton = $cartAsideDeliveryNote.querySelector(
      ".delivery-note__button"
    );
    const $buttonIcon = $deliveryNoteButton.querySelector(".button__icon");
    const $iconUnticked = $buttonIcon.querySelector(".icon__unticked");
    const $iconTicked = $buttonIcon.querySelector(".icon__ticked");

    const $deliveryNoteTextarea = $cartAsideDeliveryNote.querySelector(
      ".delivery-note__textarea"
    );

    $deliveryNoteButton.addEventListener("click", async (event) => {
      event.preventDefault();

      if (
        $cartAsideDeliveryNote.classList.contains(
          "cart-aside__delivery-note--active"
        )
      ) {
        $iconUnticked.classList.remove("hidden");
        $iconTicked.classList.add("hidden");

        $deliveryNoteTextarea.classList.add("hidden");
        $deliveryNoteTextarea.dataset.value = $deliveryNoteTextarea.value;
        $deliveryNoteTextarea.value = "";
        $cartAsideDeliveryNote.classList.remove(
          "cart-aside__delivery-note--active"
        );

        const res = await fetch("/cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({ note: "" }),
        });
      } else {
        $iconTicked.classList.remove("hidden");
        $iconUnticked.classList.add("hidden");

        $deliveryNoteTextarea.classList.remove("hidden");
        if ($deliveryNoteTextarea.dataset.value) {
          $deliveryNoteTextarea.value = $deliveryNoteTextarea.dataset.value;
        } else {
          $deliveryNoteTextarea.value = "";
        }
        $cartAsideDeliveryNote.classList.add(
          "cart-aside__delivery-note--active"
        );
      }
    });

    const $cartAsideRecommendedItems = $cartAside.querySelector(
      ".cart-aside__recommended-items"
    );
    // Mobile / tablet recommended products swiper - Add buttons are bound above with the desktop cards
    if ($cartAsideRecommendedItems) {
      const $recomendedItemsSwiper = $cartAsideRecommendedItems.querySelector(
        ".recommended-items__swiper"
      );
      if ($recomendedItemsSwiper) {
        // The markup is replaced on re-render, so drop the old instance before creating a new one
        this.recommendedItemsSwiper?.destroy(true, false);

        this.recommendedItemsSwiper = new Swiper($recomendedItemsSwiper, {
          slidesPerView: "auto",
          spaceBetween: 8,
          navigation: {
            // Pass elements rather than selectors - the arrows sit outside the swiper element
            nextEl: $cartAsideRecommendedItems.querySelector(
              ".recommended-items__next"
            ),
            prevEl: $cartAsideRecommendedItems.querySelector(
              ".recommended-items__prev"
            ),
          },
        });
      }
    }

    const $cartAsideCheckout = $cartAside.querySelector(
      ".cart-aside__checkout"
    );
    $cartAsideCheckout.addEventListener("click", async (event) => {
      event.preventDefault();
      if ($deliveryNoteTextarea.value != "") {
        const res = await fetch("/cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({ note: $deliveryNoteTextarea.value ?? "" }),
        });
      }

      window.location = "/checkout";
    });

    // Handle Any Ceramic Cup Upsell Buttons. Some live outside of the cart, but this will catch all of them and only bind the function when it hasn't already been bound to that button
    const $ceramicCupAddToCartButtons = document.querySelectorAll(
      ".ceramic-mug__add-to-cart-button"
    );
    if ($ceramicCupAddToCartButtons.length > 0) {
      $ceramicCupAddToCartButtons.forEach(($ceramicCupAddToCartButton) => {
        if (!$ceramicCupAddToCartButton.classList.contains("bound")) {
          $ceramicCupAddToCartButton.addEventListener("click", (e) => {
            $ceramicCupAddToCartButton.classList.add(
              "button--disabled",
              "pointer-events-none"
            );
            this.handleCeramicMugAddToCart(this.ceramicMugData);
          });
          $ceramicCupAddToCartButton.classList.add("bound");
        }
      });
    }
  };

  reRenderCartAside = ($element, newSectionText) => {
    // Get the text of the new section and render it to a div thats not in the DOM
    const $newSection = document.createElement("div");
    $newSection.innerHTML = newSectionText;
    const $newCartAside = $newSection.querySelector(".cart-aside");

    // Recommended products panel sits outside the container - swap it so in-cart products drop out
    const $currentRecomendedProducts = $element.querySelector(
      ".cart-aside__recomended-products"
    );
    const $newRecomendedProducts = $newCartAside.querySelector(
      ".cart-aside__recomended-products"
    );
    if ($currentRecomendedProducts && $newRecomendedProducts) {
      $currentRecomendedProducts.innerHTML = $newRecomendedProducts.innerHTML;
      $currentRecomendedProducts.classList.value =
        $newRecomendedProducts.classList.value;
    }

    const $currentAsideContainer = $element.querySelector(
      ".cart-aside__container"
    );
    const $newAsideContainer = $newCartAside.querySelector(
      ".cart-aside__container"
    );

    if (
      $currentAsideContainer.classList.contains(
        "cart-aside__container--empty"
      ) &&
      !$newAsideContainer.classList.contains("cart-aside__container--empty")
    ) {
      $currentAsideContainer.innerHTML = $newAsideContainer.innerHTML;
      $currentAsideContainer.classList.remove("cart-aside__container--empty");
    } else if (
      $newAsideContainer.classList.contains("cart-aside__container--empty") &&
      !$currentAsideContainer.classList.contains("cart-aside__container--empty")
    ) {
      $currentAsideContainer.innerHTML = $newAsideContainer.innerHTML;
      $currentAsideContainer.classList.add("cart-aside__container--empty");
    } else {
      // Set the current line items to the new line items
      const $currentLineItems = $currentAsideContainer.querySelector(
        ".cart-aside__line-items"
      );
      const $newLineItems = $newAsideContainer.querySelector(
        ".cart-aside__line-items"
      );

      if ($currentLineItems && $newLineItems) {
        $currentLineItems.innerHTML = $newLineItems.innerHTML;
      }

      const $currentFreePostage = $currentAsideContainer.querySelector(
        ".cart-aside__free-postage"
      );
      const $newFreePostage = $newAsideContainer.querySelector(
        ".cart-aside__free-postage"
      );
      if ($currentFreePostage && $newFreePostage) {
        $currentFreePostage.innerHTML = $newFreePostage.innerHTML;
      }

      const $currentRecomended = $currentAsideContainer.querySelector(
        ".cart-aside__recommended-items"
      );
      const $newFreeRecomended = $newAsideContainer.querySelector(
        ".cart-aside__recommended-items"
      );
      if ($currentRecomended && $newFreeRecomended) {
        $currentRecomended.innerHTML = $newFreeRecomended.innerHTML;
        $currentRecomended.classList.value = $newFreeRecomended.classList.value;
      }

      // Ceramic Upsell Mug Wrapper
      const $currentCermamicMugWrapper = $currentAsideContainer.querySelector(
        ".cart-aside__mug-upsell-container"
      );
      const $newCeramicMugWrapper = $newAsideContainer.querySelector(
        ".cart-aside__mug-upsell-container"
      );

      if ($currentCermamicMugWrapper && $newCeramicMugWrapper) {
        $currentCermamicMugWrapper.innerHTML = $newCeramicMugWrapper.innerHTML;
      }

      // Set the cart aside footer to the new cart aside footer
      const $currentFooter = $element.querySelector(".cart-aside__footer");
      const $newFooter = $newCartAside.querySelector(".cart-aside__footer");

      if ($currentFooter && $newFooter) {
        $currentFooter.innerHTML = $newFooter.innerHTML;
      }
    }

    this.setUpCartAside($element);
  };

  reRenderSections = (sections) => {
    // Check if sections exists before trying to access it
    if (!sections) {
      console.warn("Cart response did not include sections data");
      return;
    }

    const $header = document.querySelector("header.header");
    if ($header && sections["header"]) {
      this.reRenderHeader($header, sections["header"]);
    }

    const $cartAside = document.querySelector("aside.cart-aside");
    if ($cartAside && sections["cart-aside"]) {
      this.reRenderCartAside($cartAside, sections["cart-aside"]);
    }

    const $cartTemplate = document.querySelector("section.cart-template");
    if ($cartTemplate && sections["cart-template"]) {
      this.reRenderCartTemplate($cartTemplate, sections["cart-template"]);
    }

    if (window?.loyaltylion?.ui?.refresh) {
      window.loyaltylion.ui.refresh();
    }
  };

  // The following functions are used to update/get the cart

  updateLineItemQuantity = async (key, quantity) => {
    if (key) {
      // Try to get the current cart to verify the key format
      try {
        const cartResponse = await fetch("/cart.js");
        const cartData = await cartResponse.json();

        // Check if the key exists in the cart
        let lineItem = cartData.items.find((item) => item.key === key);

        // If not found by exact key, try to find by variant ID (for Givy items)
        if (!lineItem) {
          const variantId = key.split(":")[0]; // Extract variant ID from composite key
          lineItem = cartData.items.find(
            (item) => item.variant_id == variantId
          );
        }

        if (!lineItem) {
          console.error(
            "Line item key not found in cart for quantity update:",
            key
          );
          return null;
        } else {
          // Use the actual key from the cart
          key = lineItem.key;
        }
      } catch (error) {
        console.error("Failed to fetch cart data for quantity update:", error);
      }

      const requestJson = {
        id: key,
        quantity: parseInt(quantity),
        sections: this.sections,
      };

      const response = await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestJson),
      });

      if (!response.ok) {
        console.error(
          "Failed to update line item quantity:",
          response.status,
          response.statusText
        );
        try {
          const errorData = await response.json();
          console.error("Error response:", errorData);
        } catch (e) {
          console.error("Could not parse error response");
        }
        return null;
      }

      const json = await response.json();
      return await this.syncCartState(json);
    } else {
      return null;
    }
  };

  removeLineItemFromCart = async (key) => {
    if (key) {
      // Try to get the current cart to verify the key format
      try {
        const cartResponse = await fetch("/cart.js");
        const cartData = await cartResponse.json();

        // Check if the key exists in the cart
        let lineItem = cartData.items.find((item) => item.key === key);

        // If not found by exact key, try to find by variant ID (for Givy items)
        if (!lineItem) {
          const variantId = key.split(":")[0]; // Extract variant ID from composite key
          lineItem = cartData.items.find(
            (item) => item.variant_id == variantId
          );
        }

        if (!lineItem) {
          console.error("Line item key not found in cart:", key);
          return null;
        } else {
          // Use the actual key from the cart
          key = lineItem.key;
        }
      } catch (error) {
        console.error("Failed to fetch cart data:", error);
      }

      const requestJson = {
        id: key,
        quantity: 0,
        sections: this.sections,
      };

      const response = await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestJson),
      });
      const json = await response.json();
      return await this.syncCartState(json);
    } else {
      return null;
    }
  };

  clearCart = async () => {
    const requestJson = {
      sections: this.sections,
    };
    const response = await fetch("/cart/clear.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestJson),
    });

    if (!response.ok) {
      console.error(
        "Failed to clear cart:",
        response.status,
        response.statusText
      );
      return null;
    }

    const json = await response.json();
    if (json && json.sections) {
      this.reRenderSections(json.sections);
    }
    return json;
  };

  addItemToCart = async (variantId, quantity, sellingPlanId = null) => {
    if (variantId !== undefined && Number.isInteger(quantity)) {
      const itemObject = {
        id: variantId,
        quantity: quantity,
      };

      if (sellingPlanId) {
        itemObject.selling_plan = sellingPlanId;
      }

      const requestJson = {
        items: [itemObject],
        sections: this.sections,
      };
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestJson),
      });

      const data = await response.json();

      if (response.ok) {
        return await this.syncCartState();
      } else {
        const errorMessage =
          data.description || data.message || "Unable to add to cart";
        console.error("Add to cart error:", errorMessage, data);
        return null;
      }
    } else {
      return null;
    }
  };

  quickAddItemToCart = (variantId, sellingPlanId = null) =>
    this.addItemToCart(variantId, 1, sellingPlanId);

  getCart = async () => {
    const response = await fetch("/cart.js", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (response.ok) {
      const json = await response.json();
      return json;
    } else {
      return null;
    }
  };

  removeSubscription = async (key, variantId, quantity) => {
    if (key) {
      // Remove the subscription from the cart
      const removeRequestJson = {
        id: key,
        quantity: 0,
      };
      const removeResponse = await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(removeRequestJson),
      });

      const itemObject = {
        id: variantId,
        quantity: quantity,
      };
      const addRequestJson = {
        items: [itemObject],
        sections: this.sections,
      };
      await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(addRequestJson),
      });
      return await this.syncCartState();
    }
  };

  addSubscription = async (key, variantId, quantity, sellingPlanId) => {
    if (key) {
      // Remove the subscription from the cart
      const removeRequestJson = {
        id: key,
        quantity: 0,
      };
      const removeResponse = await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(removeRequestJson),
      });

      const itemObject = {
        id: variantId,
        quantity: quantity,
        selling_plan: sellingPlanId,
      };
      const addRequestJson = {
        items: [itemObject],
        sections: this.sections,
      };
      await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(addRequestJson),
      });
      return await this.syncCartState();
    }
  };

  openCartAside = () => {
    if (this.useCartAside) {
      const $cartAsideBackground = document.querySelector(
        ".cart-aside__background"
      );
      const $cartAside = $cartAsideBackground.querySelector("aside.cart-aside");
      if ($cartAside.classList.contains("translate-x-full")) {
        const $body = document.querySelector("body");
        $body.classList.add("overflow-y-hidden");
        $cartAsideBackground.classList.remove("pointer-events-none");
        $cartAsideBackground.classList.add("bg-black", "bg-opacity-40");
        $cartAside.classList.remove(
          "translate-x-full",
          "ponter-events-none",
          "hidden"
        );
      }
    } else {
      window.location = "/cart";
    }
  };

  // Ceramic Mug functions
  handleCeramicMugAddToCart = async (ceramicMugData) => {
    if (ceramicMugData) {
      if (this.ceramicMugUpsellIsActive()) {
        const cartJson = await this.getCart();
        if (cartJson) {
          // Does the cart have a subscription (normal or prepaid) in it?
          const hasSubscription = cartJson.items.some(
            (item) => !!item.selling_plan_allocation
          );

          // Get the target Variant id for adding to cart
          const targetVariantId = hasSubscription
            ? parseInt(ceramicMugData.subscription_variant_id)
            : parseInt(ceramicMugData.non_subscription_variant_id);

          await this.addItemToCart(targetVariantId, 1);
          this.openCartAside();

          // Hide the PDP one if it exists
          const $pdpCeramicUpsell = document.querySelector(
            ".product-template .ceramic-mug__upsell"
          );
          if ($pdpCeramicUpsell) {
            $pdpCeramicUpsell.classList.add("hidden");
          }
        } else {
          console.log(
            "failed to fetch cart data, could not determine which Ceramic Mug variant should be added"
          );
          alert(
            "An error has occurred - we were unable to complete that request. Please refresh the page and try again."
          );
          return;
        }
      } else {
        console.log(
          "ceramic upsell is not active or missing data - this Add to Cart should not exist"
        );
        alert(
          "An error has occurred - we were unable to process that request. Please refresh the page and try again."
        );
        return;
      }
    } else {
      console.log(
        "Json data for ceramic mug was not present - unable to process adding of mug to cart."
      );
      alert(
        "An error has occurred - we were unable to perform that action. Please refresh the page and try again."
      );
    }
  };

  // ─── Unified post-mutation sync ───────────────────────────────────────────

  processCartSideEffects = async (cartJson) => {
    // If the cart is empty, nothing to process
    if (!cartJson.items) {
      return null;
    }

    // All changes are accumulated here before any requests are made.
    // toRemove holds item *keys* (unique per line), toAdd holds { id, quantity } pairs.
    // toUpdate holds item key → desired quantity, for in-place corrections that don't need a remove+re-add.
    const toRemove = new Set();
    const toAdd = [];
    const toUpdate = new Map();

    // First, the Legacy Gifting System - check that we have something to work with
    const hasAnyLegacyGifts =
      this.giftData?.enable_oneoff_free_gift ||
      this.giftData?.enable_subscription_free_gift ||
      this.giftData?.enable_order_free_gift;

    // ensure gift data is present in the JSON too
    if (this.giftData && hasAnyLegacyGifts) {
      // Tally non-gift items so thresholds can be evaluated accurately
      let oneoffCount = 0,
        oneoffValue = 0,
        subscriptionCount = 0,
        totalValue = 0;

      cartJson.items.forEach((item) => {
        // Gifts (including the standard gift) must not count toward the thresholds, so skip them in this tally
        const isLegacyGift =
          (this.giftData.enable_order_free_gift &&
            item.variant_id == this.giftData?.ordergift?.product_variant?.id) ||
          (this.giftData.enable_subscription_free_gift &&
            item.variant_id ==
              this.giftData?.subscription_gift?.product_variant?.id) ||
          (this.giftData.enable_oneoff_free_gift &&
            item.variant_id ==
              this.giftData?.oneoff_gift?.product_variant?.id) ||
          (this.giftData.enable_standard_free_gift &&
            item.variant_id ==
              this.giftData?.standard_gift?.product_variant?.id);

        if (isLegacyGift) {
          return;
        }

        if (item?.selling_plan_allocation) {
          // Only count recurring (subscription) plans — prepaid has a selling plan but is not recurring
          const isRecurring =
            item.selling_plan_allocation?.selling_plan?.recurring_deliveries;
          if (isRecurring) {
            subscriptionCount += parseInt(item.quantity);
          }
        } else {
          oneoffCount += parseInt(item.quantity);
          oneoffValue += parseInt(item.final_line_price);
        }

        totalValue += parseInt(item.final_line_price);
      });

      // Determine which single legacy gift should be in cart, by priority (order → subscription → oneoff).
      // Only one can be active at a time — a higher-priority gift qualifying automatically displaces a lower one.
      let winningGiftId = null;

      if (
        this.giftData.enable_order_free_gift &&
        this.giftData?.ordergift?.product_variant?.id != "" &&
        parseInt(this.giftData.ordergift_threshold) >= 0 &&
        totalValue >= parseInt(this.giftData.ordergift_threshold) * 100
      ) {
        // Order gift qualifies
        winningGiftId = this.giftData?.ordergift?.product_variant?.id;
      } else if (
        this.giftData.enable_subscription_free_gift &&
        this.giftData?.subscription_gift?.product_variant?.id != "" &&
        parseInt(this.giftData.subscription_gift_threshold) >= 0 &&
        totalValue >=
          parseInt(this.giftData.subscription_gift_threshold) * 100 &&
        subscriptionCount > 0 &&
        sessionStorage.getItem("gtm-reactivate") != "true"
      ) {
        // Subscription gift qualifies
        winningGiftId = this.giftData?.subscription_gift?.product_variant?.id;
      } else if (
        this.giftData.enable_oneoff_free_gift &&
        this.giftData?.oneoff_gift?.product_variant?.id != "" &&
        parseInt(this.giftData.oneoff_gift_threshold) >= 0 &&
        totalValue >= parseInt(this.giftData.oneoff_gift_threshold) * 100 &&
        oneoffCount > 0
      ) {
        // Oneoff gift qualifies
        winningGiftId = this.giftData?.oneoff_gift?.product_variant?.id;
      }

      // Build a list of all possible legacy gift variant IDs so we can identify them in the cart
      const legacyGiftVariantIds = [
        this.giftData.enable_order_free_gift
          ? this.giftData?.ordergift?.product_variant?.id
          : null,
        this.giftData.enable_subscription_free_gift
          ? this.giftData?.subscription_gift?.product_variant?.id
          : null,
        this.giftData.enable_oneoff_free_gift
          ? this.giftData?.oneoff_gift?.product_variant?.id
          : null,
      ]
        .filter(Boolean)
        .map((id) => parseInt(id));

      // Remove any legacy gift in cart that isn't the winning gift —
      // this handles both stale gifts and gifts displaced by a higher-priority one taking over
      cartJson.items.forEach((item) => {
        const isLegacyGiftInCart = legacyGiftVariantIds.includes(
          parseInt(item.variant_id)
        );
        const isWinningGift =
          winningGiftId &&
          parseInt(item.variant_id) === parseInt(winningGiftId);

        if (isLegacyGiftInCart && !isWinningGift) {
          toRemove.add(item.key);
        }
      });

      // Add the winning gift if it qualifies and isn't already in cart or queued
      if (winningGiftId) {
        const giftInCart = cartJson.items.some(
          (item) => parseInt(item.variant_id) == parseInt(winningGiftId)
        );
        const giftAlreadyQueued = toAdd.some(
          (item) => parseInt(item.id) === parseInt(winningGiftId)
        );

        if (!giftInCart && !giftAlreadyQueued) {
          toAdd.push({ id: winningGiftId, quantity: 1 });
        }
      }
    }

    // Standard Gift - added to any order over its threshold, regardless of purchase type.
    // Runs independently of the legacy gifts above, so it sits alongside whichever one has won.
    const standardGiftId = parseInt(
      this.giftData?.standard_gift?.product_variant?.id
    );

    if (standardGiftId) {
      // Every configured gift variant — these don't count as paid items or toward the threshold
      const giftVariantIds = [
        this.giftData?.standard_gift?.product_variant?.id,
        this.giftData?.ordergift?.product_variant?.id,
        this.giftData?.subscription_gift?.product_variant?.id,
        this.giftData?.oneoff_gift?.product_variant?.id,
        ...(this.blockGiftData?.product_gifts || []).map(
          (rule) => rule.gift_variant?.id
        ),
      ]
        .filter(Boolean)
        .map((id) => parseInt(id));

      let paidCount = 0,
        paidValue = 0;

      cartJson.items.forEach((item) => {
        if (giftVariantIds.includes(parseInt(item.variant_id))) {
          return;
        }

        paidCount += parseInt(item.quantity);
        paidValue += parseInt(item.final_line_price);
      });

      // A blank threshold comes through as "" — treat it as 0 so the gift is always added
      const standardGiftThreshold =
        parseInt(this.giftData.standard_gift_threshold) || 0;

      // Needs at least one paid item, otherwise the gift would be added to an empty cart
      // and the customer could never empty it
      const standardGiftQualifies =
        this.giftData.enable_standard_free_gift &&
        this.giftData.standard_gift.product_variant.available &&
        paidCount > 0 &&
        paidValue >= standardGiftThreshold * 100;

      const standardGiftLines = cartJson.items.filter(
        (item) => parseInt(item.variant_id) === standardGiftId
      );

      if (standardGiftQualifies) {
        if (standardGiftLines.length === 0) {
          const giftAlreadyQueued = toAdd.some(
            (item) => parseInt(item.id) === standardGiftId
          );

          if (!giftAlreadyQueued) {
            toAdd.push({ id: standardGiftId, quantity: 1 });
          }
        } else {
          // Remove any duplicate lines (multi-tab race) and keep the quantity at 1
          standardGiftLines
            .slice(1)
            .forEach((duplicate) => toRemove.add(duplicate.key));

          if (standardGiftLines[0].quantity > 1) {
            toUpdate.set(standardGiftLines[0].key, 1);
          }
        }
      } else {
        // Disabled, under the threshold, or no paid items left — take it out
        standardGiftLines.forEach((item) => toRemove.add(item.key));
      }
    }

    // Cart Aside Block Gifts Setup

    if (this.blockGiftData?.product_gifts?.length) {
      // First we check through the rules to see if we need to remove any gifts from cart after the last mutation was performed
      this.blockGiftData.product_gifts.forEach((rule) => {
        // Skip rules that have no gift variant configured
        if (rule.gift_variant?.id) {
          // A trigger is valid if any cart item matches the product ID and the required purchase type
          const triggerStillValid = cartJson.items.some((item) => {
            const productIdMatch = rule.trigger_product_ids.includes(
              String(item.product_id)
            );
            if (!productIdMatch) {
              return false;
            }

            // We don't need to check Purchase type if the rule is "any"
            if (rule.purchase_type === "any") {
              return true;
            }

            const hasSellingPlan = !!item.selling_plan_allocation;
            if (rule.purchase_type === "onetime_purchase") {
              return !hasSellingPlan;
            }

            const isRecurring =
              item.selling_plan_allocation?.selling_plan?.recurring_deliveries;

            if (rule.purchase_type === "subscription") {
              // Returns true if both conditions are true, false if either or both are false
              return hasSellingPlan && isRecurring;
            }

            if (rule.purchase_type === "prepaid") {
              return hasSellingPlan && !isRecurring;
            }

            return false;
          });

          // If the trigger is gone but the gift is still in cart, mark it for removal
          if (!triggerStillValid) {
            const giftInCart = cartJson.items.find(
              (item) =>
                parseInt(item.variant_id) === parseInt(rule.gift_variant.id)
            );

            if (giftInCart) {
              toRemove.add(giftInCart.key);
            }
          }
        }
      });
    }

    // Now we need to check for any rules that have been matched so that we can add those gifts to the cart
    if (this.blockGiftData?.product_gifts?.length) {
      this.blockGiftData.product_gifts.forEach((rule) => {
        // Skip rules with no gift variant, or where the gift is unavailable
        if (!rule.gift_variant?.id || !rule.gift_variant?.available) {
          return;
        }

        // Same trigger logic as above — check product ID match and purchase type
        const triggerFound = cartJson.items.some((item) => {
          // Look for product id matches from the rule to the items in cart
          const productIdMatch = rule.trigger_product_ids.includes(
            String(item.product_id)
          );
          if (!productIdMatch) {
            return false;
          }

          if (rule.purchase_type === "any") {
            return true;
          }

          const hasSellingPlan = !!item.selling_plan_allocation;
          if (rule.purchase_type === "onetime_purchase") {
            return !hasSellingPlan;
          }

          const isRecurring =
            item.selling_plan_allocation?.selling_plan?.recurring_deliveries;
          if (rule.purchase_type === "subscription") {
            return hasSellingPlan && isRecurring;
          }

          if (rule.purchase_type === "prepaid") {
            return hasSellingPlan && !isRecurring;
          }
          return false;
        });

        if (triggerFound) {
          // Don't add if already physically in cart
          const giftInCart = cartJson.items.some(
            (item) =>
              parseInt(item.variant_id) === parseInt(rule.gift_variant.id)
          );

          // Don't add if already queued — gifts max quantity is 1, and the same gift could match multiple rules
          const giftAlreadyQueued = toAdd.some(
            (item) => parseInt(item.id) === parseInt(rule.gift_variant.id)
          );

          if (!giftInCart && !giftAlreadyQueued) {
            toAdd.push({ id: rule.gift_variant.id, quantity: 1 });
          }
        }
      });
    }

    // Finally, Ceramic Mug Variant Swapping based on whether a subscription item is in cart or not

    // Both variant IDs must be configured — if either is missing, skip the whole mug block
    const subVarId = parseInt(this.ceramicMugData?.subscription_variant_id);
    const nonSubVarId = parseInt(
      this.ceramicMugData?.non_subscription_variant_id
    );

    if (subVarId && nonSubVarId) {
      // Find ALL mug line items — handles multi-tab race condition where both variants end up in cart
      const mugItems = cartJson.items.filter(
        (item) =>
          parseInt(item.variant_id) === subVarId ||
          parseInt(item.variant_id) === nonSubVarId
      );

      if (mugItems.length > 0) {
        const mugItem = mugItems[0];

        // Remove any duplicate mug lines — these result from two tabs adding simultaneously
        if (mugItems.length > 1) {
          mugItems.slice(1).forEach((duplicate) => toRemove.add(duplicate.key));
        }

        if (!this.ceramicMugData?.ceramic_mug_upsell_enabled) {
          // Client has disabled the mug upsell entirely — remove it regardless of variant
          toRemove.add(mugItem.key);
        } else if (
          !this.ceramicMugData?.ceramic_mug_is_available &&
          parseInt(mugItem.variant_id) === subVarId
        ) {
          // The subscription variant is out of stock and it's what's currently in cart — remove it
          toRemove.add(mugItem.key);
        } else {
          // Determine whether the cart contains a subscription (excluding the mug itself)
          const hasSubscription = cartJson.items.some(
            (item) =>
              parseInt(item.variant_id) !== subVarId &&
              parseInt(item.variant_id) !== nonSubVarId &&
              !!item.selling_plan_allocation
          );

          // Subscriptions get the subscription variant; everyone else gets the non-subscription variant
          const targetVariantId = hasSubscription ? subVarId : nonSubVarId;

          if (parseInt(mugItem.variant_id) !== targetVariantId) {
            // Wrong variant in cart — swap it out
            toRemove.add(mugItem.key);

            const mugAlreadyQueued = toAdd.some(
              (item) => parseInt(item.id) === targetVariantId
            );

            if (!mugAlreadyQueued) {
              // Always add with quantity 1 — mug should never have qty > 1
              toAdd.push({ id: targetVariantId, quantity: 1 });
            }
          } else if (mugItem.quantity > 1) {
            // Correct variant but quantity crept above 1 (multi-tab race) — correct it in place
            toUpdate.set(mugItem.key, 1);
          }
        }
      }
    }

    // Final step - adding / removing from cart
    // Sections HTML is captured from whichever mutation call runs last.
    // Null means nothing changed — syncCartState will fall back to a terminal update.js call.

    let sectionsHtml = null;

    if (toRemove.size > 0 || toUpdate.size > 0) {
      // Build a positional updates array: one entry per cart line.
      // Items in toRemove get 0, items in toUpdate get their corrected quantity, everything else is unchanged.
      const updates = cartJson.items.map((item) => {
        if (toRemove.has(item.key)) {
          return 0;
        }
        if (toUpdate.has(item.key)) {
          return toUpdate.get(item.key);
        }
        return item.quantity;
      });

      // Only request sections on the removal call if there are no additions following it —
      // if additions are coming, we'll get sections from the add.js call instead
      const removalRequestBody =
        toAdd.length > 0 ? { updates } : { updates, sections: this.sections };

      const removeResponse = await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(removalRequestBody),
      });

      const removeJson = await removeResponse.json();

      // If no additions follow, this is our final mutation — capture the sections now
      if (toAdd.length === 0) {
        sectionsHtml = removeJson.sections;
      }
    }

    if (toAdd.length > 0) {
      // Include sections in the add.js request — this is always the last mutation call - so the response will reflect the fully settled cart state
      const addResponse = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: toAdd, sections: this.sections }),
      });

      const addJson = await addResponse.json();
      sectionsHtml = addJson.sections;
    }

    // Return the sections HTML if any mutation was made, or null if nothing changed.
    // syncCartState uses this to skip the terminal update.js call when sections are already available.
    return sectionsHtml;
  };

  // Process any gifts and/or variant swappages after a cart mutation
  syncCartState = async (initialCartJson = null) => {
    /*
      Every cart mutation should be calling this function. However, not every cart api call returns the full Cart JSON.
      If an add.js call was made, and the cart wasn't fetched, the json passed in would not be the Cart json.
      Check that we received the Cart json, and if we didn't, re-fetch it so that we have the most up to date version after the mutation that called this
    */

    let isFullCart = false;
    if (initialCartJson != null && typeof initialCartJson.token === "string") {
      isFullCart = true;
    }

    let cartJson = isFullCart ? initialCartJson : await this.getCart();

    if (cartJson) {
      // Run all gift + mug logic in a single analysis-then-batch pass.
      // Returns rendered sections HTML if any mutation was made, or null if nothing changed.
      const sections = await this.processCartSideEffects(cartJson);

      if (sections) {
        // processCartSideEffects made changes and included sections in its last request — use them directly
        this.reRenderSections(sections);
      } else {
        // Nothing was changed - so we need to perform a pretend update in order to get the Sections that allow us to re-render the HTML.
        const finalResponse = await fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ sections: this.sections }),
        });
        const finalJson = await finalResponse.json();
        this.reRenderSections(finalJson.sections);
      }

      return true;
    } else {
      console.log("SyncCartState failed to fetch cart on initial call");
    }
  };

  // ──────────────────────────────────────────────────────────────────────────

  // Returns true only when the feature is on, the subscription variant is in stock,
  // and both variant IDs are configured — used as a bailout check throughout
  ceramicMugUpsellIsActive = () => {
    return !!(
      this.ceramicMugData?.ceramic_mug_upsell_enabled &&
      this.ceramicMugData?.ceramic_mug_is_available &&
      this.ceramicMugData?.subscription_variant_id > 0 &&
      this.ceramicMugData?.non_subscription_variant_id > 0
    );
  };
}

export default Cart;
